import {IInputFile} from 'models/library/common';

export const isValidFormValue = (value: string | number | boolean | IInputFile) => (value ? true : false);
